import { getMemberships } from "api/methods";
import type { Models } from "api/types";
import { ProductCardLarge } from "molecules/cards/product-card-large/ProductCardLarge";
import { getDiscountCustomColor, getDiscountText } from "services/ListingHelperService";

type Membership = Awaited<ReturnType<typeof getMemberships>>[number];

/**
 * A membership hit rendered from its REST detail (`GET /memberships`): the card needs the billing-period fields,
 * which the index does not carry.
 */
export const CatalogMembershipCard = ({
  membership,
  shopDiscounts,
  customShopCategories,
  onClick,
  guestMode,
  isRecommended,
}: {
  membership: Membership;
  shopDiscounts: Models<"ShopDiscountModel"> | undefined;
  customShopCategories: Models<"CategoryListingsResult">[] | undefined;
  onClick: () => void;
  guestMode: boolean | undefined;
  isRecommended: boolean;
}) => {
  const rawDiscount = shopDiscounts?.membershipDiscounts[membership.id];
  // Sign-up reward discounts are never badged.
  const discount = rawDiscount?.isSignUpReward ? undefined : rawDiscount;

  return (
    <ProductCardLarge
      itemId={membership.id}
      title={membership.name}
      description={membership.description ?? ""}
      imageUrl={membership.imageUrl}
      type="Membership"
      tag=""
      concerns={[]}
      price={membership.monthlyCost}
      onClick={onClick}
      discount={getDiscountText(discount, "Membership")}
      discountData={discount}
      customColor={getDiscountCustomColor(discount, customShopCategories)}
      guestMode={guestMode}
      isRecommended={isRecommended}
      billingPeriodInterval={membership.billingPeriodInterval}
      billingPeriodIntervalCount={membership.billingPeriodIntervalCount}
      billingPeriodCost={membership.billingPeriodCost}
    />
  );
};
